export default __webpack_public_path__ + "static/media/marke_2.30bb2924.png";